import { computed } from 'vue';
import router from '@/router';
import type { RouteParams } from 'vue-router';

export const useRepoId = (
  connector: string = '%2F',
  namespace: string | string[] = '',
  routeName: string | string[] = ''
) => {
  const repoId = computed(() => {
    const routeParams = router.currentRoute.value.params;
    let routeNamespace = namespace || routeParams.namespace;
    const routeRepoName = routeName || routeParams.repoName;
    if (!routeNamespace || !routeRepoName) return '';
    // 实际上namespace只有一个，gh_mirrors是特例，项目的id应该是namespace+reponame，gh_mirrors的镜像项目需要拼接gh_mirrors
    return `${routeNamespace}${connector}${routeRepoName}`;
  });
  return { repoId };
};

export const useGetNamespace = (params: RouteParams) => {
  const routeNamespace = computed(() => {
    return params.namespace;
  });
  return { namespace: routeNamespace };
};
